<template>
  <div class="caseVeiw content-part">
    <div class="banner">
      <img :src="currentLg.banner" alt="" />
    </div>
    <div class="main">
      <div class="main-content">
        <div class="case-veiw-contain">
          <div class="left">
            <div v-show="locale == 'CN'" v-html="content"></div>
            <div v-show="locale == 'EN'" v-html="contentEn"></div>
            <div class="page">
              <div class="page-left">{{ currentLg.preP }}</div>
              <div class="page-right">{{ currentLg.nextP }}</div>
            </div>
          </div>
          <div class="right">
            <p class="title">{{ currentLg.relation }}</p>
            <ul class="list-item">
              <li v-for="i in relationList" :key="i.id">
                <div class="text">
                  <p>
                    <span>{{ locale == "CN" ? i.title : i.titleEn }}</span>
                  </p>
                  <img :src="i.imgUrl" alt="" />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import language from "./../language/case/index";
export default {
  data() {
    return {
      id: "",
      content: "",
      contentEn: "",
      type: "",
      relationList: [],
    };
  },
  mounted() {
    if (this.$route.query.id && this.$route.query.type) {
      this.id = this.$route.query.id;
      this.type = this.$route.query.type;
      this.getDetail();
      this.getList();
    } else {
      this.$router.push("/index_pc/case");
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    currentLg() {
      return language[this.locale];
    },
  },
  methods: {
    getDetail() {
      this.$http
        .get("/api/portal/project/query", {
          params: {
            id: this.id,
          },
        })
        .then((res) => {
          // console.log(res)
          this.content = res.data && res.data.content;
          this.contentEn = res.data && res.data.contentEn;
        });
    },
    getList() {
      this.$http
        .get("/api/portal/project/queryPage", {
          params: {
            type: this.type,
            pageNo: 1,
            pageSize: 10,
          },
        })
        .then((res) => {
          const { items = [] } = res.data;
          this.relationList = items
            .filter((i) => i.id != this.id)
            .filter((item, index) => index <= 3);
        });
    },
    changetype(type) {
      this.$router.push("/case?type=" + type);
    },
  },
};
</script>

<style lang="less" scoped>
.caseVeiw {
  .banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    width: 100vw;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .main {
    .main-content {
      width: auto;
      margin: 0 15vw;
      .case-header {
        height: 88px;
        position: relative;
        margin: 0px auto 0px auto;
        border-bottom: 1px dotted #cccccc;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        .case-header-left {
          margin-top: 29px;
          > li {
            display: inline-block;
            line-height: 50px;
            color: #4e4e4e;
            font-size: 14px;
          }
        }
        .typeUl {
          display: flex;
          margin-top: 29px;
          li {
            box-sizing: border-box;
            padding: 0 26px 0 25px;
            line-height: 50px;
            height: 50px;
            font-size: 16px;
            position: relative;
            color: #4e4e4e;
            cursor: pointer;
          }
          li.light {
            color: #029cfe;
          }
          li:after {
            position: absolute;
            content: "";
            height: 14px;
            width: 1px;
            background: #cccccc;
            top: 19px;
            right: 0;
          }
        }
      }
      .case-veiw-contain {
        display: flex;
        box-sizing: border-box;
        padding-top: 74px;
        display: flex;

        .left {
          margin-bottom: 67px;
          flex: 1;
          li {
            list-style-type: disc;
          }
          .page {
            border-top: 1px solid #eaeaea;
            padding-top: 62px;
            overflow: hidden;
            height: 45px;
            line-height: 45px;
            display: flex;
            > div {
              flex: 1;
              height: 45px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #4e4e4e;
              font-size: 14px;
              display: block;
            }
            .page-left {
              padding-left: 86px;
              background: url(https://1rc.xiniu.com/rc/Contents/43189/images/EIMS_C_3_1_Upli.png?d=20181101112030215)
                no-repeat left center;
            }
            .page-right {
              text-align: right;
              padding-right: 86px;
              background: url(https://1rc.xiniu.com/rc/Contents/43189/images/EIMS_C_3_1_Downli_hover.png?d=20181101112030215)
                no-repeat right center;
            }
          }
        }
        .right {
          width: 302px;
          box-sizing: border-box;
          padding: 0 32px;
          border-left: 1px dotted #d2d2d2;
          margin-bottom: 67px;

          .title {
            font-size: 20px;
            color: #4e4e4e;
            font-family: SourceHanSansCN;
            font-weight: bold;
            color: #262626;
            padding-bottom: 28px;
          }
          .list-item {
            li {
              padding-bottom: 21px;
              p.name {
                height: 45px;
                line-height: 54px;
                font-size: 14px;
                color: #000000;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .text {
                width: 255px;
                height: 178px;
                border-radius: 8px;
                position: relative;
                p {
                  width: 255px;
                  position: absolute;
                  bottom: 0;
                  background-color: rgba(0, 0, 0, 0.4);
                  color: #fff;
                  border-bottom-left-radius: 8px;
                  border-bottom-right-radius: 8px;
                  height: 32px;
                  line-height: 32px;
                  span {
                    padding-left: 16px;
                    font-size: 16px;
                    font-family: Source Han Sans SC;
                    font-weight: 400;
                    color: #ffffff;
                  }
                }
                img {
                  width: 100%;
                  border-radius: 8px;
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/caseView.vue